import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function TwoPaneLayout({ children = [] }: { children: any }) {
  return (
    <>
      <div
      style={{
        height: '80px',
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 15,
        backgroundColor: '#2E2F3C',
      }}
    >
      <div
        className={`h-full flex flex-col-reverse items-start transition-all duration-500 md:flex-row md:justify-between md:items-center `}
        style={{marginTop:"1px"}}
      >
    <Link to="/">
      <div className="w-[150px]">
        <Logo className="ml-6" />
      </div>
    </Link>
  
  </div>
    </div>
    <div className="w-full min-h-full flex bg-primary-200">
      <div className="w-full md:w-1/2 min-h-screen bg-white">{children}</div>
      <div className="w-0 md:w-1/2 min-h-full bg-gray-0">
        <div className="w-full h-full bg-two-pane-sm md:bg-two-pane-lg bg-center bg-contain bg-no-repeat" />
      </div>
    </div>
    </>
  )
}
